import React, {useState} from 'react';
import VisitorsComparasionDate from "./VisitorsComparasionDate";
import VisitorsComparasionDateHourly from "./VisitorsComparasionDateHourly";
import VisitorsComparasionDateMonthly from "./VisitorsComparasionDateMonthly";
import VisitorsComparasionDateGr from "./VisitorsComparasionDateGr";
import VisitorsComparasionDateHourlyGr from "./VisitorsComparasionDateHourlyGr";
import VisitorsComparasionDateMonthlyGr from "./VisitorsComparasionDateMonthlyGr";

const VisitorComparasionDate = () => {
    const [seldate, setseldate] = useState("hourly")
    let selList = [
        {
            name: "Почасовая",
            value: "hourly"
        },
        {
            name: "Ежедневно",
            value: "daily"
        },
        {
            name: "Ежемесячно",
            value: "monthly"
        },

    ]
    const [seldategr, setseldategr] = useState("hourly")
    let selListgr = [
        {
            name: "Почасовая",
            value: "hourly"
        },
        {
            name: "Ежедневно",
            value: "daily"
        },
        {
            name: "Ежемесячно",
            value: "monthly"
        },

    ]
    return (
        <div className="visitor-comparasion">

            {
                seldate === "daily"
                    ?
                    <VisitorsComparasionDate seldate={seldate} setseldate={setseldate} selList={selList}/>
                    : seldate === "hourly"
                        ?
                        <VisitorsComparasionDateHourly seldate={seldate} setseldate={setseldate} selList={selList}/>

                        : seldate === "monthly"
                            ?

                            <VisitorsComparasionDateMonthly seldate={seldate} setseldate={setseldate} selList={selList}/>

                            :
                            ""
            }

            {
                seldategr === "daily"
                    ?
                    <VisitorsComparasionDateGr seldate={seldategr} setseldate={setseldategr} selList={selListgr}/>
                    : seldategr === "hourly"
                        ?
                        <VisitorsComparasionDateHourlyGr seldate={seldategr} setseldate={setseldategr} selList={selListgr}/>

                        : seldategr === "monthly"
                            ?
                            <VisitorsComparasionDateMonthlyGr seldate={seldategr} setseldate={setseldategr} selList={selListgr}/>

                            :
                            ""
            }

            {/*<PeakHoursComparasion />*/}
            {/*<AnaluzCustomComparasion />*/}
            {/*<DailyAnalyticsComparasion />*/}

        </div>
    );
};

export default VisitorComparasionDate;